import HrAnnouncements from "../../../components/hr/HrAnnouncements"


export default function HrViewAnnouncement() {
    return (
        <>
            <HrAnnouncements />
        </>
    )
}